const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class DisputeQueryConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async updateDispute({ disputeId, comment, submit }) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/disputes/${disputeId}`,
        method: 'PUT',
        data: {
          comment,
          submit,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getEvidenceFile({ disputeId }) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/disputes/${disputeId}/evidence`,
        responseType: 'blob',
        method: 'GET',
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async listDisputes({
    sort, startDisputeDate, endDisputeDate,
    startPayoutDate, endPayoutDate,
    startEvidenceDueDate, endEvidenceDueDate, dynamicSearch,
    startDate, endDate, page = 0, maxPerPage = 10 }) {
    try {
      const params = {
        sort,
        page,
        maxPerPage,
        startDisputeDate,
        endDisputeDate,
        startPayoutDate,
        endPayoutDate,
        startEvidenceDueDate,
        endEvidenceDueDate,
        startDate,
        endDate,
        dynamicSearch,
      };

      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/disputes`, {
        params,
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  DisputeQueryConnector,
};
